import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConstants } from 'src/app/app.constants';
import { FormService } from 'src/app/services/form.service';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { OpcionService } from 'src/app/services/opcion.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-opcionmodal',
  templateUrl: './opcionmodal.component.html',
  styleUrls: ['./opcionmodal.component.css']
})
export class OpcionmodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  usuario: any;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private opcionService: OpcionService) {
  }

  ngOnInit(): void {
    this.usuario = this.utils.obtenerDatosUsuario().usuario;
    this.form = this.formService.getOpcionModalForm(this.data, this.usuario);
  }

  accept() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modal.mostrarModalCargando();
    if (this.form.value.idOpcion > 0)
      this.update(this.form.value);
    else
      this.save(this.form.value);
  }

  save(opcion) {
    let request = {
      idOpcion: opcion.idOpcion,
      idPregunta: opcion.idPregunta,
      opcion: opcion.opcion,
      descripcion: opcion.descripcion,
      usuario: opcion.usuario
    };
    this.opcionService.guardar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo guardar la opción, intente de nuevo', true);
    });
  }

  update(opcion) {
    let request = {
      idOpcion: opcion.idOpcion,
      idPregunta: opcion.idPregunta,
      opcion: opcion.opcion,
      descripcion: opcion.descripcion,
      usuario: opcion.usuario
    };
    this.opcionService.actualizar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo actualizar la opción, intente de nuevo', true);
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

}
